'use client';
import { Link } from 'react-router-dom';
import styles from './pagination.module.sass';
import { useMediaQuery } from '@intigral/hooks';
import { LinkWrapper } from '../LinkWrapper';

export interface PaginationProps extends React.HTMLAttributes<HTMLDivElement> {
    onClick?: () => void;
    seeAllUrl?: string;
    seeAllText?: string;
    mobileHidden?: boolean;
    manageAddons?: boolean;
}

export const Pagination = ({
    onClick,
    seeAllUrl,
    seeAllText,
    mobileHidden = true,
    className,
    manageAddons = false,
    ...props
}: PaginationProps) => {
    const isMobile = useMediaQuery('(max-width: 924px)');

    return (
        <div className={styles.holder} {...props}>
            {isMobile ? (
                !mobileHidden && <div className={`${className} ${styles.paging}`}></div>
            ) : (
                <div className={`${className} ${styles.paging}`}></div>
            )}
            {seeAllUrl && !manageAddons && (
                <Link to={seeAllUrl} onClick={onClick} className={styles.link}>
                    {seeAllText}
                </Link>
            )}
            {seeAllUrl && manageAddons && (
                <LinkWrapper
                    link={{ text: seeAllText, href: seeAllUrl }}
                    className={styles.link}
                    onClick={onClick}
                />
            )}
        </div>
    );
};
